<template>
  <BaseCardSection title="Doprava">

    <!-- Volba typu dopravy pomocí Bootstrap button group -->
    <div class="row mb-4">
      <div class="col-12">
        <label class="form-label d-block fw-bold mb-2">Způsob dopravy:</label>
        <div class="btn-group w-100" role="group" aria-label="Typ dopravy">
          <input type="radio" class="btn-check" name="transportType" id="type-none" value="none"
                 v-model="selectedType" autocomplete="off">
          <label class="btn btn-outline-primary" for="type-none">
            <i class="bi bi-house-door me-1"></i> Osobní odběr
          </label>

          <input type="radio" class="btn-check" name="transportType" id="type-internal" value="internal"
                 v-model="selectedType" autocomplete="off">
          <label class="btn btn-outline-primary" for="type-internal">
            <i class="bi bi-truck me-1"></i> Standardní doprava
          </label>

          <input type="radio" class="btn-check" name="transportType" id="type-external" value="external"
                 v-model="selectedType" autocomplete="off">
          <label class="btn btn-outline-primary" for="type-external">
            <i class="bi bi-box-seam me-1"></i> Přepravní služba
          </label>
        </div>
      </div>
    </div>

    <!-- 1) Standardní doprava (Internal) -->
    <fieldset class="row g-3" v-if="selectedType === 'internal'">
      <div class="row gy-2">
        <WeightPeopleCount :weight="maxWeight"
                           v-model:peopleCount="recomendedPeopleCount"/>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="people-count">Počet osob na cestě:</label>
          <input type="number" step="1" min="0" class="form-control" id="people-count" name="people-count"
                 v-model="transportationInternal.peopleCount"
                 v-validate="{
                     rules: { required: true, min: 0 },
                     message: { required: 'Počet osob na cestě je povinný', min: 'Minimálně 0 osob' },
                     options: { showValidState: false }
                   }">
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="time-on-way">Čas na cestě (h):</label>
          <input type="number" step="1" min="0" class="form-control" id="time-on-way" name="time-on-way"
                 v-model="transportationInternal.timeOnWay"
                 v-validate="{
                     rules: { required: true, min: 0 },
                     message: { required: 'Čas na cestě je povinný', min: 'Minimálně 0 h' },
                     options: { showValidState: false }
                   }">
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="total-weight">Celková váha (kg):</label>
          <input type="number" class="form-control" :value="totalWeight" disabled>
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="max-weight">Nejtěžší dílec (kg):</label>
          <input type="number" class="form-control" :value="maxWeight" disabled>
        </div>
      </div>

      <div class="row gy-2">
        <CarsCount :weight="totalWeight"/>
      </div>

      <div class="row gy-2">
        <div class="form-group col-sm-12 col-md-3 position-relative">
          <label class="form-label" for="distance">Vzdálenost tam i zpět (km):</label>
          <input type="number" step="0.1" min="0" class="form-control" id="distance" name="distance"
                 v-model="transportationInternal.distance"
                 v-validate="{
                     rules: { required: true, min: 0 },
                     message: { required: 'Vzdálenost tam i zpět je povinná', min: 'Minimálně 0' },
                     options: { showValidState: false }
                   }"
                 v-tooltip="'Zadejte vzdálenost tam i zpět.'"
                 data-tooltip-position="top"
                 data-tooltip-trigger="focus">
        </div>
        <div class="form-group col-sm-12 col-md-3 position-relative">
          <label class="form-label" for="distance-from-parking">Vzdálenost k instalaci (m):</label>
          <input type="number" step="1" min="0" class="form-control" id="distance-from-parking"
                 v-model="transportationInternal.distanceFromParking"
                 v-validate="{
                   rules: { required: true, min: 0 },
                   message: { required: 'Vzdálenost k instalaci je povinná', min: 'Minimálně 0' },
                   options: { showValidState: false }}">
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="floor-with-lift">Patra s výtahem:</label>
          <input type="number" step="1" min="0" class="form-control" id="floor-with-lift"
                 v-model="transportationInternal.floorWithLift"
                 v-validate="{
                   rules: { required: true, min: 0 },
                   message: { required: 'Patra s výtahem jsou povinná', min: 'Minimálně 0' },
                   options: { showValidState: false }}">
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="floor-without-lift">Patra bez výtahu:</label>
          <input type="number" step="1" min="0" class="form-control" id="floor-without-lift"
                 v-model="transportationInternal.floorWithoutLift"
                 v-validate="{
                   rules: { required: true, min: 0 },
                   message: { required: 'Patra bez výtahu jsou povinná', min: 'Minimálně 0' },
                   options: { showValidState: false }}">
        </div>
      </div>
    </fieldset>

    <!-- 2) Odeslání přepravní službou (External) -->
    <fieldset class="row g-3" v-if="selectedType === 'external'">
      <div class="row gy-2">
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="transport-price">Cena dopravy (Kč):</label>
          <input type="number" step="0.01" min="0" class="form-control" id="transport-price"
                 v-model="transportationInternal.transportPrice"
                 v-validate="{
                   rules: { required: true, min: 0 },
                   message: { required: 'Cena dopravy je povinná', min: 'Minimálně 0' },
                   options: { showValidState: false }}">
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="packaging-price">Cena balného (Kč):</label>
          <input type="number" step="0.01" min="0" class="form-control" id="packaging-price"
                 v-model="transportationInternal.packagingPrice"
                 v-validate="{
                   rules: { required: true, min: 0 },
                   message: { required: 'Cena balného je povinná', min: 'Minimálně 0' },
                   options: { showValidState: false }}">
        </div>
      </div>
    </fieldset>

    <!-- Společný výběr dílců (pro internal i external) -->
    <div class="row gy-2 mt-4" v-if="selectedType !== 'none'">
      <hr>
      <h5 class="mb-3">Vyber dílce pro přepravu:</h5>
      <div class="form-group">
        <CalculationItemsSelector :caption="'transportation'"
                                  :calculation-items="calculationItems"
                                  v-model:selectedItems="transportationInternal.itemList"
                                  v-model:totalWeight="totalWeight"
                                  v-model:maxWeight="maxWeight"/>
      </div>
    </div>

  </BaseCardSection>
</template>

<script setup>
import {ref, watch, onMounted, defineProps, defineEmits} from 'vue'
import Transportation from "@/models/Transportation";
import CalculationItemsSelector from "@/components/items/CalculationItemsSelector.vue";
import WeightPeopleCount from "@/components/base/WeightPeopleCount.vue";
import CarsCount from "@/components/base/CarsCount.vue";
import BaseCardSection from "@/components/base/BaseCardSection.vue";

const props = defineProps({
  calculationItems: Array,
  transportation: Object,
  cid: String
})

const emit = defineEmits(['update:transportation'])

const totalWeight = ref(0)
const maxWeight = ref(0)
const recomendedPeopleCount = ref(0)
const selectedType = ref('none') // 'none' | 'internal' | 'external'
const transportationInternal = ref({})

const initEmptyTransportation = (type = 'internal') => {
  return new Transportation({
    calculation_uid: props.cid,
    type: type,
    floor_with_lift: 0,
    floor_without_lift: 0,
    distance_from_parking: 0,
    distance: 0,
    people_count: 0,
    time_on_way: 0,
    transport_price: 0,
    packaging_price: 0,
    item_list: []
  })
}

// Sledování změny typu (radio buttonů)
watch(selectedType, (newType) => {
  if (newType === 'none') {
    emit('update:transportation', null)
  } else {
    // Nastavení typu do modelu pro backend
    transportationInternal.value.type = newType
    emit('update:transportation', transportationInternal.value)
  }
})

// Sledování změn uvnitř modelu (hluboké sledování)
watch(transportationInternal, (newVal) => {
  if (selectedType.value !== 'none') {
    emit('update:transportation', newVal)
  }
}, {deep: true})

// Automatické doplnění doporučeného počtu lidí (jen pro internal)
watch(recomendedPeopleCount, (newVal) => {
  if (selectedType.value === 'internal' &&
      (!transportationInternal.value.peopleCount)) {
    transportationInternal.value.peopleCount = newVal
  }
})

onMounted(() => {
  if (props.transportation) {
    transportationInternal.value = props.transportation
    selectedType.value = props.transportation.type || 'internal'
  } else {
    transportationInternal.value = initEmptyTransportation()
    selectedType.value = 'none'
  }
})
</script>

<style scoped>
.btn-group .btn {
  flex: 1;
}
</style>